import { render, staticRenderFns } from "./vsSelect.vue?vue&type=template&id=55cd4644&lang=html&"
import script from "./vsSelect.vue?vue&type=script&lang=js&"
export * from "./vsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports